import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ZodIssue } from 'zod';

export const useValidationStore = defineStore('validation', () => {
    const errors = ref<Record<string, string>>({});

    // Set an error for a specific field
    const setError = (field: string, message: string) => {
        errors.value[field] = message;
    };

    // Get the error for a field
    const getError = (field: string): string | undefined => {
        return errors.value[field];
    };

    // Clear the error for a specific field
    const clearError = (field: string) => {
        delete errors.value[field];
    };

    // Clear all errors
    const clearAll = () => {
        errors.value = {};
    };

    // Check if any errors exist
    const hasErrors = () => {
        return Object.keys(errors.value).length > 0;
    };

    const setZodErrors = (issues: ZodIssue[]) => {
        clearAll();

        issues.forEach((issue) => {
            if (issue.path.length > 0) {
                setError(issue.path[0] as string, issue.message);
            }
        });
    };

    return {
        errors,
        setError,
        getError,
        clearError,
        clearAll,
        hasErrors,
        setZodErrors,
    };
});
